import Vue from "vue";

const {$wApi} = Vue.prototype;

const state = {
    $wApi,
    hotInstance : null,
    experimentTypePopFlag : false, //실험타입 모달레이어 플래그
    editAttributePopFlag : false, //속성타입 모달레이어 플래그
    resultConfirmPopFlag : false, //엑셀업로드 시 확인 모달레이어 플래그
    versionHistoryPopFlag : false, //버전이력 확인 모달레이어 플래그
    nodeMarkSettingPopFlag : false, //노드표시설정 모달레이어 플래그
    keshImageServicePopFlag : false, //Kesh 이미지서비스 모달레이어 플래그
    orgCodeInputPopFlag : false, //기관코드입력 모달레이어 플래그
    protocolDetailObj : {
        protocolDetailPopFlag : false,
        protocolDetailData : {}
    }, //연결된 프로토콜 상세화면 모달레이어 플래그
    connectProtocolObj : {
        connectProtocolPopFlag : false,
        connectNodeInfo : {}
    }, //연결된 프로토콜 모달레이어 플래그
    searchProtocolObj : {
        searchProtocolPopFlag : false,
        connectNodeInfo : {}
    }, //프로토콜 조회 모달레이어 플래그
    saveHistoryObj : {
        saveHistoryPopFlag : false,
        cellInfo : {}
    }, //Cell 변경이력 모달레이어 플래그
    fileUploadObj : {
        fileUploadPopFlag : false,
        fileMappingInfo : {}
    }, //파일 업로드 모달레이어 플래그
    attributePoolObj : {
        attrPoolPopFlag : false,
        attrPoolInfo : {}
    }, //속성풀 수정 모달레이어 플래그
    visualizationPopObj : {
        visualizationPopFlag : false,
        selectedNodeInfo : {}
    }, //시각화 팝업
    experimentResultMode : "readOnly", //실험입력 모드
    selectedProcess : null, //선택된 프로세스 정보
    selectedReleaseProcess : null, //선택된 공개공정도 정보
    selectedNode : null, //선택된 노드정보
    selectedExperiment : null, //선택된 실험정보
    dictionaryPropertyList : [], //사전속성 리스트
    processPropertyListOfNode : [], //선택된 노드의 공정도 속성 리스트
    processPropertyListOfExperiment : [], //선택된 실험정보의 공정도속성 리스트
    experimentList : [], // 실험리스트
    editorLayoutClass : 'layout_type_4',
    experimentTypeSaveFlag : null, // 실험타입 구분값
    filteredExperimentList : [], //사용가능한 실험타입 리스트.(실험입력 셀릭트박스 로우추가시 사용)
    experimentValueSetList : [], //실험입력 row 추가시 기본값 데이터 셋 리스트.
    customSettings : [],
    propertyClassList : [],
    vocabularyList : [],
    companyNameArray : [
        // ETRI, KRICT, KIST, 동국대, 한밭대, 인하대, 단국대, 경희대, 성균관대, 포항공대, 부산대
        { value: "ETRI",    text: "한국전자통신연구원" },
        { value: "KRICT",   text: "한국화학연구원" },
        { value: "KIST",    text: "과학기술연구원" },
        { value: "DGU",     text: "동국대학교" },
        { value: "HANBAT",  text: "한밭대학교" },
        { value: "INU",     text: "인천대학교" },
        { value: "DKU",     text: "단국대학교" },
        { value: "KHU",     text: "경희대학교" },
        { value: "SKKU",    text: "성균관대학교" },
        { value: "POSTECH", text: "포항공과대학교" },
        { value: "PNU",     text: "부산대학교" },

        { value: "KGU",     text: "경기대학교" },
        { value: "KIER",    text: "에너지기술연구원" },
        { value: "KAIST",   text: "카이스트" },
        { value: "HYU",     text: "한양대학교" },
        { value: "SNU",     text: "서울대학교" },
        { value: "AJU",     text: "아주대학교" },
        { value: "UNIST",   text: "울산과학기술원" },
        { value: "KIMM",    text: "기계연구원" }
    ],
}; // end of state

const getters = {
    hotInstance(state: any) {
        return state.hotInstance;
    },
    getOrgCodeArray(state: any) {
        return state.companyNameArray;
    },
    getExperimentTypePopFlag(state: any) {
        return state.experimentTypePopFlag;
    },
    getEditAttributePopFlag(state: any) {
        return state.editAttributePopFlag;
    },
    getResultConfirmPopFlag(state: any) {
        return state.resultConfirmPopFlag;
    },
    getVersionHistoryPopFlag(state: any) {
        return state.versionHistoryPopFlag;
    },
    getAttributePoolObj(state: any) {
        return state.attributePoolObj;
    },
    getSaveHistoryObj(state: any) {
        return state.saveHistoryObj;
    },
    getFileUploadObj(state: any) {
        return state.fileUploadObj;
    },
    getNodeMarkSettingPopFlag(state: any) {
        return state.nodeMarkSettingPopFlag;
    },
    getConnectProtocolObj(state: any) {
        return state.connectProtocolObj;
    },
    getSearchProtocolObj(state: any) {
        return state.searchProtocolObj;
    },
    getProtocolDetailObj(state: any) {
        return state.protocolDetailObj;
    },
    getKeshImageServicePopFlag(state: any) {
        return state.keshImageServicePopFlag;
    },
    getOrgCodeInputPopFlag(state: any) {
        return state.orgCodeInputPopFlag;
    },
    getEditorLayoutClass(state: any) {
        return state.editorLayoutClass;
    },
    getSelectedProcess(state: any) {
        return state.selectedProcess;
    },
    getSelectedReleaseProcess(state: any) {
        return state.selectedReleaseProcess;
    },
    getSelectedNode(state: any) {
        return state.selectedNode;
    },
    getSelectedExperiment(state: any) {
        return state.selectedExperiment;
    },
    getDictionaryPropertyList(state: any) {
        return state.dictionaryPropertyList;
    },
    getProcessPropertyList(state: any) {
        return state.processPropertyListOfNode;
    },
    getExperimentList(state: any) {
        return state.experimentList;
    },
    getProcessPropertyListOfExperiment(state: any) {
        return state.processPropertyListOfExperiment;
    },
    getExperimentTypeSaveFlag(state: any) {
        return state.experimentTypeSaveFlag;
    },
    getFilteredExperimentList(state: any) {
        return state.filteredExperimentList;
    },
    getExperimentResultMode(state: any) {
        return state.experimentResultMode;
    },
    getExperimentValueSetList(state: any) {
        return state.experimentValueSetList;
    },
    getCustomSettings(state: any) {
        return state.customSettings;
    },
    getVisualizationPopObj(state: any) {
        return state.visualizationPopObj;
    },
    getPropertyClassList(state: any) {
        return state.propertyClassList;
    },
    getVocabularyList(state: any) {
        return state.vocabularyList;
    },
}; // end of getters 

const mutations = {
    setState(state: any, [key, value]) {
        state[key] = value;
    },
    setHotInstance(state: any, dataObj: object) {
        state.hotInstance = dataObj;
    },
    setExperimentTypePopFlag(state: any, openFlag: boolean) {
        state.experimentTypePopFlag = openFlag;
    },
    setEditAttributePopFlag(state: any, openFlag: boolean) {
        state.editAttributePopFlag = openFlag;
    },
    setResultConfirmPopFlag(state: any, openFlag: boolean) {
        state.resultConfirmPopFlag = openFlag;
    },
    setVersionHistoryPopFlag(state: any, openFlag: boolean) {
        state.versionHistoryPopFlag = openFlag;
    },
    setAttributePoolObj(state: any, { openFlag, dataObj }: { openFlag: boolean, dataObj: object }) {
        state.attributePoolObj.attrPoolPopFlag = openFlag;
        state.attributePoolObj.attrPoolInfo = {...dataObj};
    },
    setSaveHistoryObj(state: any, { openFlag, dataObj }: { openFlag: boolean, dataObj: object }) {
        state.saveHistoryObj.saveHistoryPopFlag = openFlag;
        state.saveHistoryObj.cellInfo = {...dataObj};
    },
    setNodeMarkSettingPopFlag(state: any, openFlag: boolean) {
        state.nodeMarkSettingPopFlag = openFlag;
    },
    setConnectProtocolObj(state: any, { openFlag, dataObj }: { openFlag: boolean, dataObj: object }) {
        state.connectProtocolObj.connectProtocolPopFlag = openFlag;
        state.connectProtocolObj.connectNodeInfo = {...dataObj};
    },
    setSearchProtocolObj(state: any, { openFlag, dataObj }: { openFlag: boolean, dataObj: object }) {
        state.searchProtocolObj.searchProtocolPopFlag = openFlag;
        state.searchProtocolObj.connectNodeInfo = {...dataObj};
    },
    setProtocolDetailObj(state: any, { openFlag, dataObj }: { openFlag: boolean, dataObj: object }) {
        state.protocolDetailObj.protocolDetailPopFlag = openFlag;
        state.protocolDetailObj.protocolDetailData = {...dataObj};
    },
    setKeshImageServicePopFlag(state: any, openFlag: boolean) {
        state.keshImageServicePopFlag = openFlag;
    },
    setOrgCodeInputPopFlag(state: any, openFlag: boolean) {
        state.orgCodeInputPopFlag = openFlag;
    },
    setFileUploadObj(state: any, { openFlag, dataObj }: { openFlag: boolean, dataObj: object }) {
        state.fileUploadObj.fileUploadPopFlag = openFlag;
        state.fileUploadObj.fileMappingInfo = {...dataObj};
    },
    setEditorLayoutClass(state: any, adjustClassName: string) {
        state.editorLayoutClass = adjustClassName;
    },
    setSelectedProcess(state: any, dataObj: object) {
        state.selectedProcess = {...dataObj};
        //console.log('[hub.ts]state.selectedProcess = ',state.selectedProcess);
    },
    setSelectedReleaseProcess(state: any, dataObj: object) {
        state.selectedReleaseProcess = {...dataObj};
        //console.log('[hub.ts]state.selectedReleaseProcess = ',state.selectedReleaseProcess);
    },
    setSelectedNode(state: any, dataObj: object) {
        state.selectedNode = {...dataObj};
        //console.log('[hub.ts]state.selectedNode = ',state.selectedNode);
    },
    setSelectedExperiment(state: any, dataObj: object) {
        state.selectedExperiment = {...dataObj};
        //console.log('[hub.ts]state.selectedExperiment = ',state.selectedExperiment);
    },
    setDictionaryPropertyList(state: any, list: object) {
        state.dictionaryPropertyList = list;
    },
    setProcessPropertyList(state: any, list: object) {
        state.processPropertyListOfNode = list;
    },
    setExperimentList(state: any, list: object) {
        state.experimentList = list;
    },
    setProcessPropertyListOfExperiment(state: any, list: object) {
        state.processPropertyListOfExperiment = list;
    },
    setExperimentTypeSaveFlag(state: any, saveFlag: String) {
        state.experimentTypeSaveFlag = saveFlag;
    },
    setFilteredExperimentList(state: any, list: object) {
        state.filteredExperimentList = list;
    },
    setExperimentResultMode(state: any, mode: String) {
        state.experimentResultMode = mode;
    },
    setExperimentValueSetList(state: any, list: object) {
        state.experimentValueSetList = list;
    },
    setCustomSettings(state: any, list: object) {
        state.customSettings = list;
    },
    setVisualizationPopObj(state: any, { openFlag, dataObj }: { openFlag: boolean, dataObj: object }) {
        state.visualizationPopObj.visualizationPopFlag = openFlag;
        state.visualizationPopObj.selectedNodeInfo = {...dataObj};
    },
    setPropertyClassList(state: any, list: object) {
        state.propertyClassList = list;
    },
    setVocabularyList(state: any, list: object) {
        state.vocabularyList = list;
    },
}; // end of mutations 

const actions = {
    async fetchCustomSettings({commit}, processId) {
        let {$wApi} = state;
        let customSettings = await $wApi.experiment.custom.get({processId : processId});
        //console.log('[hub.ts]fetchCustomSettings = {}',customSettings);
        commit('setCustomSettings', customSettings);
    },

    async fetchDictionaryPropertyList({commit}, node) {
        let {$wApi} = state;
        let dictionaryPropList = await $wApi.property.getDictionaryPropertyList({
            dictionaryId : node.dictionaryId
        });
        //console.log('[hub.ts]fetchDictionaryPropertyList = {}',dictionaryPropList);
        commit('setDictionaryPropertyList', dictionaryPropList);
    },

    async fetchProcessPropertyList({commit}, node) {
        let {$wApi} = state;
        let processPropList = await $wApi.property.getProcessPropertyList({
            dictionaryKeyLinkId : node.dictionaryKeyLinkId
            ,processId : node.processId
            ,experimentId : node.experimentId
        });
        //console.log('[hub.ts]fetchProcessPropertyList = {}',processPropList);
        commit('setProcessPropertyList', processPropList);
    },

    async fetchProcessPropertyListOfExperiment({commit}, param) {
        let {$wApi} = state;
        let processPropList = await $wApi.property.getAllProcessPropertyList({
            processId : param.processId
            ,experimentId : param.experimentId
        });
        //console.log('[hub.ts]fetchPropOfExperiment = {}',processPropList);
        commit('setProcessPropertyListOfExperiment', processPropList);
    },

    async fetchReleaseProcessPropertyListOfExperiment({commit}, param) {
        let {$wApi} = state;
        let processPropList = await $wApi.property.getAllReleaseProcessPropertyList({
            processId : param.processId
            ,experimentId : param.experimentId
        });
        //console.log('[hub.ts]fetchReleasePropOfExperiment = {}',processPropList);
        commit('setProcessPropertyListOfExperiment', processPropList);
    },

    async fetchExperiment({commit}, param) {
        let {$wApi} = state;
        let experiment = await $wApi.experiment.getExperiment({
            processId : param.processId,
            experimentId : param.experimentId,
            flag : param.flag //select 조건. create일경우 release를 호출. 기타일 경우 일반조회
        });
        //console.log('[hub.ts]fetchExperiment = {}',experiment);
        commit('setSelectedExperiment', experiment);
    },

    async fetchDefaultExperiment({commit}, param) {
        let {$wApi} = state;
        let defalutExperiment = await $wApi.experiment.getDefalutExperiment({
            processId : param.processId
        });
        //console.log('[hub.ts]fetchDefaultExperiment = {}',defalutExperiment);
        return defalutExperiment;
    },

    async fetchExperimentList({commit}, process) {
        let {$wApi} = state;
        let experimentList = await $wApi.experiment.getExperimentList({
            processId : process.processId
        });
        //console.log('[hub.ts]fetchExperimentList = {}',experimentList);
        commit('setExperimentList', experimentList);
    },

    async updateSelectedProcess({state, commit, dispatch}, process) {
        commit('setExperimentList', []);
        commit('setSelectedProcess', {...process});
        await dispatch('fetchExperimentList', state.selectedProcess);
    },

    async updateSelectedNode({state, commit, dispatch}, nodeData) {
        commit('setDictionaryPropertyList', []);
        commit('setProcessPropertyList', []);

        //공정도기본실험타입있는지 확인하여 없으면 만들어서 해당Id return
        const defalutexperiment = await dispatch('fetchDefaultExperiment', nodeData);
        commit('setSelectedNode', {...nodeData, experimentId : defalutexperiment.experimentId});
        // selectednode가 변경될 때마다 dictionaryPropertyList(사전속성)과 processPropertyList(공정도속성)를 다시 가져옴
        await dispatch('fetchDictionaryPropertyList', state.selectedNode);
        await dispatch('fetchProcessPropertyList', state.selectedNode);
        //팝업호출
        commit('setEditAttributePopFlag', true);
    },

    async updateSelectedExperiment({state, commit, dispatch}, param) {
        commit('setSelectedExperiment', []);
        commit('setProcessPropertyListOfExperiment', []);
        commit('setExperimentTypeSaveFlag',null);

        if(param.experimentFlag === false){
            //case1. 공정도 수정중 실험을 호출한 경우 => process_property테이블 experiment(default) 테이블 조회하여 value 찾음
            const defalutexperiment = await dispatch('fetchDefaultExperiment', param);
            commit('setSelectedExperiment', defalutexperiment);
            await dispatch('fetchProcessPropertyListOfExperiment',{...param, experimentId : defalutexperiment.experimentId});
        }else if(param.experimentFlag === true){
            //case2. 실험입력 수정중 실험을 호출한 경우 => release_process_property테이블에서 process_property를 가져오고 experiment 테이블 조회하여 value 찾음
            await dispatch('fetchExperiment', param);
            await dispatch('fetchReleaseProcessPropertyListOfExperiment',{...param, experimentId : state.selectedExperiment.experimentId});
        }
        commit('setExperimentTypeSaveFlag', param.flag);
        if(param.flag =='copy') await dispatch('fetchExperimentList', param); //실험 리스트 초기화

        //팝업호출
        commit('setExperimentTypePopFlag', true);
    },

    async fetchCheckProcessProp({commit}, param) {
        let {$wApi} = state;
        const response = await $wApi.dictionary.getDictionaryKeyLinkByProcessIdAndKey({
          key: param.key,
          processId: param.processId
        });
        let processPropList = await $wApi.property.getProcessPropertyList({
            dictionaryKeyLinkId : response.id
            ,processId : param.processId
        });
        if(processPropList.length > 0){
          return processPropList.length;
        }
        return 0;
    },

    async fetchReleaseProcessPropertyListOfProcess({commit}, param) {
        let {$wApi} = state;
        const response = await $wApi.experiment.getAllExperimentValue({
          processId: param.processId
        });
        //console.log('[hub.ts]fetchReleaseProcessPropertyListOfProcess = {}',response);
        commit('setExperimentValueSetList', response);
    },
    
    async fetchPropertyClassList({commit}) {
        let {$wApi} = state;
        let propertyClassList = await $wApi.property.getPropertyClassList();
        commit('setPropertyClassList', propertyClassList);
    },
    
    async fetchVocabularyList({commit}) {
        let {$wApi} = state;
        let vocabularyList = await $wApi.property.getPropertyVocabularyList({code: null});
        commit('setVocabularyList', vocabularyList);
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};